import React from "react";
import { motion } from "framer-motion";
import { Users2, Trophy, Heart } from "lucide-react";

const initials = (name) =>
  (name || "?").split(" ").map((w) => w[0]).join("").slice(0, 2).toUpperCase();

export const PairsBoard = ({ pairs }) => {
  if (!pairs.length) {
    return (
      <div className="flex flex-col items-center justify-center text-center py-20" data-testid="pairs-empty">
        <div className="w-16 h-16 rounded-2xl bg-[#121b2d] border border-[#1e2c4a] flex items-center justify-center mb-4">
          <Users2 className="w-8 h-8 text-slate-500" />
        </div>
        <h3 className="font-heading font-bold text-xl text-slate-200">Nessuna coppia ancora</h3>
        <p className="text-slate-500 text-sm mt-1 max-w-xs">
          Registra i risultati delle partite per scoprire le coppie più affiatate.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      <p className="text-sm text-slate-400 -mt-1 mb-1">Ordinate per vittorie insieme. Scopri con chi vinci di più! 🤝</p>
      {pairs.map((p, i) => (
        <motion.div
          key={p.key}
          layout
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3, delay: i * 0.04 }}
          data-testid={`pair-card-${p.key}`}
          className={`rounded-2xl bg-[#121b2d] border p-4 flex items-center gap-4 ${i === 0 ? "border-[#ccff00]/40" : "border-[#1e2c4a]"}`}
        >
          <div className={`w-8 h-8 rounded-full flex items-center justify-center font-heading font-extrabold text-sm shrink-0 ${i === 0 ? "bg-[#ccff00] text-[#090d16]" : "bg-[#1e2c4a] text-slate-300"}`}>
            {i === 0 ? <Trophy className="w-4 h-4" /> : i + 1}
          </div>
          <div className="flex -space-x-2 shrink-0">
            {p.players.map((n, idx) => (
              <div key={idx} className="w-9 h-9 rounded-full bg-[#1e2c4a] border-2 border-[#121b2d] flex items-center justify-center text-[11px] font-bold text-slate-200">
                {initials(n)}
              </div>
            ))}
          </div>
          <div className="flex-1 min-w-0">
            <p className="font-heading font-bold text-base text-slate-100 truncate flex items-center gap-1.5">
              {p.players[0]} <Heart className="w-3 h-3 text-[#ff6b35] fill-[#ff6b35]" /> {p.players[1]}
            </p>
            <div className="flex items-center gap-3 mt-1 text-xs text-slate-400">
              <span><b className="text-slate-200">{p.played}</b> gioc.</span>
              <span className="text-[#ccff00]"><b>{p.wins}</b> V</span>
              <span className="text-[#ff4d4d]"><b>{p.losses}</b> S</span>
              <span><b className="text-slate-200">{p.win_rate}%</b></span>
            </div>
          </div>
          <div className="text-right shrink-0">
            <p className="font-heading font-extrabold text-2xl text-[#ccff00] leading-none">{p.wins}</p>
            <p className="text-[10px] uppercase tracking-wider text-slate-500">vittorie</p>
          </div>
        </motion.div>
      ))}
    </div>
  );
};
